import { Component, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { MdSnackBar } from '@angular/material';
import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import { FormBuilder, FormGroup, FormControl, AbstractControl, Validators } from '@angular/forms';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';

import { Store } from '@ngrx/store';
import * as fromCommonStore from '../../../store';
import * as commonActions from '../../../store/actions/common.actions';
import * as fromRootStore from '../../../reducers';

import { ReferenceService,CommonService } from '../../../services/index';

import { ReferenceModel } from '../../../model/index';
import * as _ from 'lodash';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

@Component({
    selector: 'merge-reference-window',
    templateUrl: './mergeReference.component.html'
})
export class mergeReferenceComponent implements OnInit {
    title: string;
    public mode: string;
    public list: any[] = [];
    @Input() from_page;
    public orgReferenceData: any[] = [];
    public dupReferenceData: any[] = [];
    @Input() referencedata: ReferenceModel[] = [];
    @Output() referenceLoadEvent = new EventEmitter();
    filteredItems: Observable<any[]>;
    // trigger-variable for Ladda
    isLoading: boolean = false;
    orgTypeCtrl: FormControl;
    dupTypeCtrl: FormControl;
    statusCtrl: FormControl;
    typeList = [];
    statusList = ['Active','Inactive'];
    filteredOrgType: Observable<any[]>;
    duplicateList: any[];
    refStrList: any[] = [];
  
    constructor(private referenceService: ReferenceService, public snackBar: MdSnackBar,
     public bsModalRef: BsModalRef, public toasterService: ToasterService, private commonService: CommonService) 
    {
         //FOR AUTO COMPLETE VALIDATION --- BRAND MODEL
        // function hasValidType(input: FormControl) {
        //     let ledgerID = input.value, retVal = null;
        //     if (ledgerID != "Doctor" && ledgerID != "Newspaper" && ledgerID != "Others") {
        //         retVal = { inValidReference: true };
        //     }
          
        //     return retVal;
        // }
       
        this.orgTypeCtrl = new FormControl('', [
            Validators.required,
            hasValidOrgRef.bind(this)
        ]);
        function hasValidOrgRef(input: FormControl) {
            let ModelID = input.value, retVal = null;
            if (ModelID == "") {
                retVal = { inValidOrgRef: true };
            }
            let fhalist = _.find(this.orgReferenceData, { 'ref_id': ModelID });
            if (!fhalist) {
                retVal = { inValidOrgRef: true };
            }
            return retVal;
        }
        this.dupTypeCtrl = new FormControl('', [
            Validators.required
        ]);
        this.statusCtrl = new FormControl('', [
            Validators.required
        ]);
        this.filteredOrgType = this.orgTypeCtrl.valueChanges
        .startWith(null)
        .map(name => name ? this.filterSerialNo(name) : this.orgReferenceData.slice());
        
     
     // this.typeList = ['Doctor', 'Newspaper', 'Others'];

     // this.typeCtrl = new FormControl();
    }

    ngOnInit(): void {

        // this.typeList = ['Doctor', 'Newspaper', 'Others'];
        // getReferenceList(): void {
            let params = {
                filter: ''
            };
            let that = this;


        this.commonService.loadReferenceList().then(function (res: any){
            that.orgReferenceData = res.data;
            // console.log("cccc",that.orgReferenceData);
            
            that.orgTypeCtrl.setValue(that.referencedata['org_reference_type']);
        })
        this.referenceService
        .getMergeReferenceList(params)
        .then(function(res: any) {
            that.dupReferenceData = res.data;
            that.duplicateList = res.data;
        });


            // this.filteredItems.subscribe(($e) => {
            //     that.orgReferenceData = $e;
            // });

            // this.referenceService
            //     .getMergeReferenceList(params)
            //     .then(function(res: any) {
            //         // that.loadingIndicator = false;
            //         // that.page.count = res.totCnt;
            //         that.orgReferenceData = res.data;
            //     });
        // }

        setTimeout(() => {
            $('#org_reference_type').focus();
        }, 1000);
    }

    storeRefId(value : any){
        if (!this.refStrList.some((item: any) => item === value)) {
            this.refStrList.push(value);
        } else {
            const indexone = this.refStrList.findIndex((item: any) => item === value);
            this.refStrList.splice(indexone, 1);
        }
        let str = JSON.stringify(this.refStrList)
        this.referencedata['dup_reference_type'] = JSON.parse(str);
    }

    searchDuplicateList(term: string): void {
        if(term) {
            this.duplicateList = this.dupReferenceData.filter((data) => new RegExp(term, 'gi').test(data.name));
            setTimeout(() => {
                document.getElementById("duplicateSearch").focus();
            }, 200);
        } else {
            this.duplicateList = this.dupReferenceData;
        }
    }

    selectDupliReference(status) {
        if (status) {
            let params = {
                filter: status.ref_id
            };
            let that = this;
            this.referenceService
                .getMergeReferenceList(params)
                .then(function(res: any) {
                    that.dupReferenceData = res.data;
                });
        }
    }

    onEnterKeyPressed(nextEl: string): void {
        $('#' + nextEl).focus();
    }
    filterSerialNo(name: string) {
        name = _.escapeRegExp(name);
        return this.orgReferenceData.filter(ha => (new RegExp(name, 'gi').test(ha.name)));
    }

    dispalyorgFn(refid: any) {
        if (this.orgReferenceData != undefined) {
            if (refid && this.orgReferenceData.length > 0) {
                let fitem = _.find(this.orgReferenceData, { 'ref_id': refid });
                return fitem['name'];
            }
        }
        return '';
    }


    onUpdateReference(): void {
        let that = this;
        // data = {
        // 	mode: this.referencedata['mode']
        // };
        this.isLoading = true;
        this.referenceService
            .onUpdateReference(this.referencedata)
            .then(function(res: any) {
                that.isLoading = false;
                if (res.success) {
                    swal('SUCCESS', res.message, 'success');
                    that.bsModalRef.hide();
                    that.referenceLoadEvent.emit();
                } else {
                    var toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: res.message
                    };

                    that.toasterService.pop(toast);
                }

            });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/reference/mergeReference.component.ts